/**
 * @generated SignedSource<<72997dd059f5a4019b6ea1d7efa41fbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerRunStateReason = "ALREADY_RUNNING" | "TIMED_OUT" | "EXECUTOR_ERROR" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
export type AgenticWorkerStartedByKind = "MANUAL" | "SCHEDULE" | "%future added value";
export type agentRunStatePastRunsQuery$variables = {
  agentId: string;
  limit: number;
  search?: string | null;
  state?: AgenticWorkerResultState | null;
};
export type agentRunStatePastRunsQuery$data = {
  readonly viewer: {
    readonly agenticWorker: {
      readonly pastRuns: {
        readonly hasMore: boolean;
        readonly counts: {
          readonly all: number;
          readonly needsReview: number;
          readonly done: number;
          readonly deleted: number;
        };
        readonly runs: ReadonlyArray<{
          readonly run: {
            readonly id: string;
            readonly scopeKind: AgenticWorkerScopeKind;
            readonly scopeRowType: AgenticWorkerRowType | null;
            readonly scopeRowId: number | null;
            readonly state: AgenticWorkerRunState;
            readonly rows: ReadonlyArray<{
              readonly rowType: AgenticWorkerRowType;
              readonly rowId: number;
            }>;
            readonly startedByKind: AgenticWorkerStartedByKind;
            readonly startedBy: {
              readonly fullName: string | null;
            } | null;
            readonly stateReason: AgenticWorkerRunStateReason | null;
            readonly foundDetail: string | null;
            readonly finishedAt: string | null;
          };
          readonly results: ReadonlyArray<{
            readonly resultId: string;
            readonly state: AgenticWorkerResultState;
            readonly rows: ReadonlyArray<{
              readonly rowType: AgenticWorkerRowType;
              readonly rowId: number;
              readonly project: {
                readonly companyProjectId: number | null;
                readonly customProjectId: string | null;
                readonly name: string | null;
                readonly projectColor: string | null;
              } | null;
            }>;
            readonly actedBy: {
              readonly fullName: string | null;
            } | null;
            readonly actedAt: string | null;
            readonly hidden: boolean;
            readonly producedAt: string | null;
          }>;
        }>;
      };
    } | null;
  } | null;
};
export type agentRunStatePastRunsQuery = {
  variables: agentRunStatePastRunsQuery$variables;
  response: agentRunStatePastRunsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "limit"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "state"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "agentId",
    "variableName": "agentId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  {
    "kind": "Variable",
    "name": "state",
    "variableName": "state"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasMore",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerPastRunCounts",
  "kind": "LinkedField",
  "name": "counts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "all",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsReview",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "done",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deleted",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v9 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerRun",
  "kind": "LinkedField",
  "name": "run",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeRowType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeRowId",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerResultRow",
      "kind": "LinkedField",
      "name": "rows",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startedByKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NovaRunAuthor",
      "kind": "LinkedField",
      "name": "startedBy",
      "plural": false,
      "selections": (v9/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "stateReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "foundDetail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "finishedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resultId",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyProjectId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customProjectId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectColor",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaRunAuthor",
  "kind": "LinkedField",
  "name": "actedBy",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actedAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hidden",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "producedAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agentRunStatePastRunsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "AgenticWorker",
            "kind": "LinkedField",
            "name": "agenticWorker",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "AgenticWorkerPastRuns",
                "kind": "LinkedField",
                "name": "pastRuns",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgenticWorkerPastRun",
                    "kind": "LinkedField",
                    "name": "runs",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgenticWorkerPastResult",
                        "kind": "LinkedField",
                        "name": "results",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgenticWorkerResultRow",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentRunStatePastRunsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "AgenticWorker",
            "kind": "LinkedField",
            "name": "agenticWorker",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "AgenticWorkerPastRuns",
                "kind": "LinkedField",
                "name": "pastRuns",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AgenticWorkerPastRun",
                    "kind": "LinkedField",
                    "name": "runs",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AgenticWorkerPastResult",
                        "kind": "LinkedField",
                        "name": "results",
                        "plural": true,
                        "selections": [
                          (v11/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "AgenticWorkerResultRow",
                            "kind": "LinkedField",
                            "name": "rows",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProjectType",
                                "kind": "LinkedField",
                                "name": "project",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f3b5292394f2aba712fe292fe8b04f4",
    "id": null,
    "metadata": {},
    "name": "agentRunStatePastRunsQuery",
    "operationKind": "query",
    "text": "query agentRunStatePastRunsQuery(\n  $agentId: String!\n  $limit: Int!\n  $search: String\n  $state: AgenticWorkerResultState\n) {\n  viewer {\n    agenticWorker(agentId: $agentId) {\n      pastRuns(limit: $limit, search: $search, state: $state) {\n        hasMore\n        counts {\n          all\n          needsReview\n          done\n          deleted\n        }\n        runs {\n          run {\n            id\n            scopeKind\n            scopeRowType\n            scopeRowId\n            state\n            rows {\n              rowType\n              rowId\n            }\n            startedByKind\n            startedBy {\n              fullName\n            }\n            stateReason\n            foundDetail\n            finishedAt\n          }\n          results {\n            resultId\n            state\n            rows {\n              rowType\n              rowId\n              project {\n                companyProjectId\n                customProjectId\n                name\n                projectColor\n                id\n              }\n            }\n            actedBy {\n              fullName\n            }\n            actedAt\n            hidden\n            producedAt\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8d7757c40ad2777f0ab884b339f39fb5";

export default node;
